const imageBaseURL = process.env.REACT_APP_BASE_URL;

export const encodedImagesURI = imageUrl => {
    if (!imageUrl) {
        return null; // Return null if imageUrl is not provided
    }
  return `${imageBaseURL}${imageUrl}`
}